// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./ide-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#ide-updater-dialog-container > .dialogBlock {
    width: 546px;
}

.ide-updater-dialog .bold {
    font-weight: bold;
}

.ide-updater-dialog--pre-download {
    display: flex;
}

.ide-updater-dialog--downloading {
    flex: 1;
}

.ide-updater-dialog--logo-container {
    margin-right: var(--arduino-button-height);
}

.ide-updater-dialog--logo {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) round;
    width: 52px;
    height: 52px;
}

.dialogContent.ide-updater-dialog
    .ide-updater-dialog--content
    .ide-updater-dialog--new-version-text.dialogSection {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-top: 0;
    min-width: 0;
}

.ide-updater-dialog .changelog {
    color: var(--theia-editor-foreground);
    background-color: var(--theia-editor-background);
    font-size: 12px;
    overflow: auto;
    padding: 0 12px;
    cursor: text;
    width: 100%;
}

.ide-updater-dialog .changelog .fallback {
    min-height: 180px;
    width: 100%;
    display: flex;
}

.ide-updater-dialog .changelog .fallback .spinner {
    align-self: center;
}

.dialogContent.ide-updater-dialog
    .ide-updater-dialog--content
    .ide-updater-dialog--new-version-text
    .dialogRow.changelog-container {
    align-items: flex-start;
    border: 1px solid var(--theia-editorWidget-border);
    border-radius: 2px;
    overflow: auto;
    max-height: 180px;
}

.ide-updater-dialog .changelog a {
    color: var(--theia-textLink-foreground);
}

.ide-updater-dialog .changelog a:hover {
    text-decoration: underline;
    cursor: pointer;
}

.ide-updater-dialog .changelog code {
    background: var(--theia-textBlockQuote-background);
    border-radius: 2px;
    padding: 0 2px;
}

.ide-updater-dialog .changelog a code {
    color: var(--theia-textLink-foreground);
}

.ide-updater-dialog .buttons-container {
    display: flex;
    justify-content: flex-end;
    margin-top: var(--arduino-button-height);
}

.ide-updater-dialog .buttons-container a.theia-button {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ide-updater-dialog .buttons-container a.theia-button:hover {
    color: var(--theia-button-foreground);
}

.ide-updater-dialog .buttons-container .push {
    margin-right: auto;
}

.ide-updater-dialog--content {
    max-height: 100%;
    overflow: hidden;
    display: flex;
}

#ide-updater-dialog-container .skip-version-button {
    margin-left: 79px;
    margin-right: auto;
}

/* https://github.com/arduino/arduino-ide/pull/2027#issuecomment-1533174638 */
/* https://github.com/eclipse-theia/theia/commit/1b5ff9ee459df14cedc0e8266dd02dae93fcd1bf#diff-d8d45a890507a01141c010ad4a6891edf2ae727cfa6dfe604cebbd667812cccbR68 */
/* Use normal whitespace handling for the changelog content in the update dialog. */
.p-Widget.dialogOverlay .dialogContent.ide-updater-dialog {
    white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/ide-updater-dialog.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yDAAuC;IACvC,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,gDAAgD;IAChD,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;IAII,uBAAuB;IACvB,kDAAkD;IAClD,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,6EAA6E;AAC7E,oKAAoK;AACpK,mFAAmF;AACnF;IACI,mBAAmB;AACvB","sourcesContent":["#ide-updater-dialog-container > .dialogBlock {\r\n    width: 546px;\r\n}\r\n\r\n.ide-updater-dialog .bold {\r\n    font-weight: bold;\r\n}\r\n\r\n.ide-updater-dialog--pre-download {\r\n    display: flex;\r\n}\r\n\r\n.ide-updater-dialog--downloading {\r\n    flex: 1;\r\n}\r\n\r\n.ide-updater-dialog--logo-container {\r\n    margin-right: var(--arduino-button-height);\r\n}\r\n\r\n.ide-updater-dialog--logo {\r\n    background: url(\"./ide-logo.png\") round;\r\n    width: 52px;\r\n    height: 52px;\r\n}\r\n\r\n.dialogContent.ide-updater-dialog\r\n    .ide-updater-dialog--content\r\n    .ide-updater-dialog--new-version-text.dialogSection {\r\n    display: flex;\r\n    flex: 1;\r\n    flex-direction: column;\r\n    margin-top: 0;\r\n    min-width: 0;\r\n}\r\n\r\n.ide-updater-dialog .changelog {\r\n    color: var(--theia-editor-foreground);\r\n    background-color: var(--theia-editor-background);\r\n    font-size: 12px;\r\n    overflow: auto;\r\n    padding: 0 12px;\r\n    cursor: text;\r\n    width: 100%;\r\n}\r\n\r\n.ide-updater-dialog .changelog .fallback {\r\n    min-height: 180px;\r\n    width: 100%;\r\n    display: flex;\r\n}\r\n\r\n.ide-updater-dialog .changelog .fallback .spinner {\r\n    align-self: center;\r\n}\r\n\r\n.dialogContent.ide-updater-dialog\r\n    .ide-updater-dialog--content\r\n    .ide-updater-dialog--new-version-text\r\n    .dialogRow.changelog-container {\r\n    align-items: flex-start;\r\n    border: 1px solid var(--theia-editorWidget-border);\r\n    border-radius: 2px;\r\n    overflow: auto;\r\n    max-height: 180px;\r\n}\r\n\r\n.ide-updater-dialog .changelog a {\r\n    color: var(--theia-textLink-foreground);\r\n}\r\n\r\n.ide-updater-dialog .changelog a:hover {\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n}\r\n\r\n.ide-updater-dialog .changelog code {\r\n    background: var(--theia-textBlockQuote-background);\r\n    border-radius: 2px;\r\n    padding: 0 2px;\r\n}\r\n\r\n.ide-updater-dialog .changelog a code {\r\n    color: var(--theia-textLink-foreground);\r\n}\r\n\r\n.ide-updater-dialog .buttons-container {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: var(--arduino-button-height);\r\n}\r\n\r\n.ide-updater-dialog .buttons-container a.theia-button {\r\n    text-decoration: none;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.ide-updater-dialog .buttons-container a.theia-button:hover {\r\n    color: var(--theia-button-foreground);\r\n}\r\n\r\n.ide-updater-dialog .buttons-container .push {\r\n    margin-right: auto;\r\n}\r\n\r\n.ide-updater-dialog--content {\r\n    max-height: 100%;\r\n    overflow: hidden;\r\n    display: flex;\r\n}\r\n\r\n#ide-updater-dialog-container .skip-version-button {\r\n    margin-left: 79px;\r\n    margin-right: auto;\r\n}\r\n\r\n/* https://github.com/arduino/arduino-ide/pull/2027#issuecomment-1533174638 */\r\n/* https://github.com/eclipse-theia/theia/commit/1b5ff9ee459df14cedc0e8266dd02dae93fcd1bf#diff-d8d45a890507a01141c010ad4a6891edf2ae727cfa6dfe604cebbd667812cccbR68 */\r\n/* Use normal whitespace handling for the changelog content in the update dialog. */\r\n.p-Widget.dialogOverlay .dialogContent.ide-updater-dialog {\r\n    white-space: normal;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
